namespace $.$$ {

	export class $shm_projects_tasks_panel extends $.$shm_projects_tasks_panel {

		@ $mol_mem
		override List_head() {
			const head = super.List_head()
			head.close_content = ()=> []
			head.add_content = ()=> [ head.Add(), this.Sort_menu() ]
			head.Controls().sub = ()=> [ head.Filter() ]
			return head
		}

	}

}
